<template>
  <el-form-item :label="label" :prop="prop">
    <el-select :value="value" class="jin-select" placeholder="请选择" @change="onChange">
      <el-option
        v-for="item in options"
        :key="item.value"
        :label="item.label"
        :value="item.value"
      />
    </el-select>
  </el-form-item>
</template>

<script>
export default {
  props: {
    label: {
      type: String,
      default: ''
    },
    prop: {
      type: String,
      default: ''
    },
    options: {
      type: Array,
      default: () => []
    },
    value: {
      type: [String, Number],
      default: undefined
    }
  },
  data() {
    return {
      // options: [
      //   {
      //     value: '选项1',
      //     label: '黄金糕'
      //   }, {
      //     value: '选项2',
      //     label: '双皮奶'
      //   }
      // ]
    }
  },
  methods: {
    onChange(v) {
      this.$emit('input', v)
    }
  }
}
</script>

<style lang="scss" scoped>
.jin-pc {
  .jin-select {
    width: 320px;
  }
}

.jin-m {
  .jin-select {
    width: 100%;
  }
}
</style>
